import type { MissionCategoryId } from '@e-socna/data-layer';

import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import type { ReferencesContext_MissionCategory } from '../../contexts/ReferencesContext';

interface Props {
  readonly categoryParentId: string | null | undefined;
  readonly categoryLeaf: string | null | undefined;
}

const buildNodePath = (
  categoryId: string,
  idMap: Readonly<Record<MissionCategoryId, ReferencesContext_MissionCategory>>,
): readonly string[] => {
  const path: string[] = [];
  let current: ReferencesContext_MissionCategory | undefined =
    idMap[categoryId as MissionCategoryId];

  while (current) {
    path.unshift(current.label);
    current = current.parentId
      ? idMap[current.parentId as MissionCategoryId]
      : undefined;
  }

  return path;
};

export const MissionCategoryPath = ({
  categoryParentId,
  categoryLeaf,
}: Readonly<Props>) => {
  const { missionCategoriesIdMap } = useReferencesContext();

  return categoryParentId && categoryLeaf
    ? [
        ...buildNodePath(categoryParentId, missionCategoriesIdMap),
        categoryLeaf,
      ].join(' > ')
    : 'Non renseignée';
};
